const typographyModalDocEmployee = {
  true: 'Cadastrar Novo Documento',
  false: 'Editar Documento'
};

export default typographyModalDocEmployee;
